<template>
    <el-dialog title="导入示例" width="50%" :visible.sync="visible">
        <pre class="pre-text">
        [卷名]XX问卷
[欢迎语] 感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！
 1、[单选题]单选题题干XXX
A、选项1
B、选项2
C、选项3
D、选项4

 2、[多选题]多选题题干XXX
A、选项1
B、选项2
C、选项3

 3、[单选题]判断题题干XXX
A、正确
B、错误

 4、[填空题]填空题题干，填空题空项需要用如(________)所示

 [文本描述]文本描术XXXX
        </pre>
        <slot/>
    </el-dialog>
</template>

<script>
export default {
    name: "example",
    data() {
        return {
            visible: false
        }
    },
    methods: {
        open() {
            this.visible = true
        },
        close() {
            this.visible = false
        }
    }
}
</script>

<style scoped>
.pre-text {
    font-size: 16px;
    font-weight: 400;
}
</style>
